module.exports = __webpack_public_path__ + "static/trainer5-7c13ed03d256984daf0a4e7be8e71455.png";